import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { type FormSectionState, type ModuleId, type ModuleResult } from '@pixacare/forms';
import { FormBridge } from '@pixacare/forms-angular';
import { FormDecorationComponent } from '@pixacare/forms-angular/ui';
import { TuiTitle } from '@taiga-ui/core';
import { ModuleResolverInputs } from '../../models/module-resolver-inputs';
import { FormManualTriggerComponent } from '../form-manual-trigger/form-manual-trigger.component';
import { FormQuestionComponent } from '../form-question/form-question.component';

@Component({
  selector: 'pxc-form-section',
  templateUrl: './form-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TuiTitle, FormQuestionComponent, FormManualTriggerComponent, FormDecorationComponent],
})
export class FormSectionComponent {
  readonly section = input.required<FormSectionState>();
  readonly sectionGroup = input.required<UntypedFormGroup>();
  readonly readOnly = input<boolean>(false);
  readonly formInputs = input.required<ModuleResolverInputs>();

  readonly moduleTriggered = output<{ moduleId: ModuleId; targetId: string; result: ModuleResult }>();
  readonly moduleReset = output<{ moduleId: ModuleId; targetId: string }>();

  private readonly formBridge = inject(FormBridge);

  readonly questions = computed(() => {
    const questions = this.formBridge.questions();
    if (!questions) {
      return [];
    }

    return this.section()
      .questions.map((id) => questions[id])
      .filter((question) => !!question && !question.isHidden);
  });
}
